import React, { Component } from 'react';
import {
  Card,
  Timeline,
  Button,
  Modal,
  Descriptions,
  Popconfirm,
  Tag,
  Space,
  message,
} from 'antd';
import {
  HistoryOutlined,
  RollbackOutlined,
  EyeOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import AgentBlueprintView from './AgentBlueprintView';

class VersionHistoryTab extends Component {
  state = {
    viewModalVisible: false,
    viewingVersion: null,
    publishModalVisible: false,
    publishNotes: '',
  };

  handlePublish = () => {
    const { publishNotes } = this.state;
    if (this.props.onPublish) {
      this.props.onPublish(publishNotes);
    }
    this.setState({ publishModalVisible: false, publishNotes: '' });
  };

  handleRollback = (version) => {
    if (this.props.onRollback) {
      this.props.onRollback(version.id);
    }
  };

  openViewModal = (version) => {
    this.setState({
      viewModalVisible: true,
      viewingVersion: version,
    });
  };

  closeViewModal = () => {
    this.setState({
      viewModalVisible: false,
      viewingVersion: null,
    });
  };

  render() {
    const {
      versions = [],
      currentVersion,
      onPublish,
      onRollback,
      loading,
    } = this.props;

    const { viewModalVisible, viewingVersion, publishModalVisible, publishNotes } = this.state;

    // Sort versions by version number descending
    const sortedVersions = [...versions].sort((a, b) => b.version - a.version);

    return (
      <div className="version-history-tab">
        <Card
          title={
            <span>
              <HistoryOutlined style={{ marginRight: 8 }} />
              Lịch sử phiên bản
            </span>
          }
          extra={
            <Button
              type="primary"
              icon={<RocketOutlined />}
              onClick={() => this.setState({ publishModalVisible: true })}
              loading={loading}
            >
              Xuất bản phiên bản mới
            </Button>
          }
        >
          {/* Timeline */}
          <Timeline mode="left">
            {sortedVersions.map((version) => {
              const isCurrent = version.version === currentVersion;
              return (
                <Timeline.Item
                  key={version.id}
                  color={isCurrent ? 'green' : 'gray'}
                  label={
                    <span style={{ fontSize: 12, color: '#999' }}>
                      {new Date(version.createdAt || version.created_at).toLocaleString('vi-VN')}
                    </span>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontWeight: 600, fontSize: 16 }}>
                          Phiên bản {version.version}
                        </span>
                        {isCurrent && (
                          <Tag color="green">Hiện tại</Tag>
                        )}
                        {version.rollbackFrom && (
                          <Tag color="orange">Khôi phục từ v{version.rollbackFrom}</Tag>
                        )}
                      </div>

                      <div style={{ color: '#666', marginTop: 4 }}>
                        {version.notes || 'Không có ghi chú'}
                      </div>

                      <div style={{ color: '#999', fontSize: 12, marginTop: 4 }}>
                        Người tạo: {version.createdBy || version.created_by || 'Không rõ'}
                      </div>
                    </div>

                    <Space style={{ marginLeft: 16 }}>
                      <Button
                        type="text"
                        icon={<EyeOutlined />}
                        onClick={() => this.openViewModal(version)}
                      >
                        Xem
                      </Button>

                      {!isCurrent && (
                        <Popconfirm
                          title="Bạn có chắc chắn muốn rollback về phiên bản này?"
                          description="Phiên bản hiện tại sẽ được lưu lại và phiên bản này sẽ trở thành phiên bản mới."
                          onConfirm={() => this.handleRollback(version)}
                          okText="Rollback"
                          cancelText="Hủy"
                        >
                          <Button
                            type="text"
                            icon={<RollbackOutlined />}
                            danger
                          >
                            Khôi phục
                          </Button>
                        </Popconfirm>
                      )}
                    </Space>
                  </div>
                </Timeline.Item>
              );
            })}
          </Timeline>

          {sortedVersions.length === 0 && (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
              <HistoryOutlined style={{ fontSize: 48, marginBottom: 16 }} />
              <div>Chưa có phiên bản nào được publish</div>
            </div>
          )}

          {/* View Version Modal */}
          <Modal
            title={`Chi tiết phiên bản ${viewingVersion?.version}`}
            open={viewModalVisible}
            onCancel={this.closeViewModal}
            footer={null}
            width={800}
          >
            {viewingVersion && (
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="Phiên bản">
                  {viewingVersion.version}
                  {viewingVersion.version === currentVersion && (
                    <Tag color="green" style={{ marginLeft: 8 }}>
                      Hiện tại
                    </Tag>
                  )}
                </Descriptions.Item>

                <Descriptions.Item label="Ghi chú">
                  {viewingVersion.notes || 'Không có ghi chú'}
                </Descriptions.Item>

                <Descriptions.Item label="Người tạo">
                  {viewingVersion.createdBy || viewingVersion.created_by || 'Không rõ'}
                </Descriptions.Item>

                <Descriptions.Item label="Thời gian tạo">
                  {new Date(viewingVersion.createdAt || viewingVersion.created_at).toLocaleString('vi-VN')}
                </Descriptions.Item>

                {viewingVersion.rollbackFrom && (
                  <Descriptions.Item label="Khôi phục từ">
                    Version {viewingVersion.rollbackFrom}
                  </Descriptions.Item>
                )}

                <Descriptions.Item label="Chi tiết cấu hình">
                  <div
                    style={{
                      maxHeight: '60vh',
                      overflow: 'auto',
                      padding: '16px',
                      background: '#fff',
                      borderRadius: '8px',
                      border: '1px solid #f0f0f0'
                    }}
                  >
                    <AgentBlueprintView 
                      config={viewingVersion.snapshot} 
                      stages={viewingVersion.snapshot.salesStages || []}
                      faqs={viewingVersion.snapshot.faqOverrides || []}
                      title={`Bản Phác Thảo Phiên Bản ${viewingVersion.version}`}
                      subTitle={`Chi tiết cấu hình được lưu vào lúc ${new Date(viewingVersion.snapshot.snapshotAt || viewingVersion.createdAt).toLocaleString('vi-VN')}`}
                    />
                  </div>
                </Descriptions.Item>
              </Descriptions>
            )}
          </Modal>

          {/* Publish Modal */}
          <Modal
            title="Xuất bản phiên bản mới"
            open={publishModalVisible}
            onOk={this.handlePublish}
            onCancel={() => this.setState({ publishModalVisible: false, publishNotes: '' })}
            okText="Xuất bản"
            cancelText="Hủy"
            confirmLoading={loading}
          >
            <p>
              Bạn sẽ tạo một phiên bản mới với cấu hình hiện tại. Phiên bản này sẽ trở thành phiên bản active.
            </p>
            <div style={{ marginTop: 16 }}>
              <label>Ghi chú (Notes):</label>
              <textarea
                className="ant-input"
                rows={3}
                value={publishNotes}
                onChange={(e) => this.setState({ publishNotes: e.target.value })}
                placeholder="Mô tả các thay đổi trong phiên bản này..."
                style={{ width: '100%', marginTop: 8 }}
              />
            </div>
          </Modal>
        </Card>
      </div>
    );
  }
}

export default VersionHistoryTab;
